export default function Services() {
  const services = [
    {
      icon: "💼",
      title: "CC CARD",
      description: "Smart NFC cards for individuals to share contacts and social media instantly.",
    },
    {
      icon: "🚀",
      title: "CC ORG",
      description: " Business NFC cards, customizable for organizations with advanced features.",
    },
    {
      icon: "📊",
      title: "CC MENU ",
      description: "Digital menus for restaurants & cafes accessible via NFC & QR code.",
    },
      {
      icon: "📊",
      title: "CC STICKER & TAG",
      description: "Small customizable NFC stickers for marketing and data sharing.",
    },
      {
      icon: "📊",
      title: "CC ID",
      description: "Smart employee cards supporting access control and information sharing.",
    },
      {
      icon: "📊",
      title: " CC BOARD  ",
      description: "Elegant NFC-enabled display boards for offices, exhibitions, and businesses.",
    },
    

  ]

  return (
    <section id="services" className="section">
      <h2>Our products </h2>
      <div className="services-grid">
        {services.map((service, index) => (
          <div key={index} className="service-card">
            <div className="service-icon">{service.icon}</div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
